import React, { useEffect, useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import useGame from './stores/useGame.jsx'
import { useFrame } from '@react-three/fiber'


export function Starlink(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/starlink_spacex_satellite.glb')
  const { actions } = useAnimations(animations, group)

  const play = useGame((state) => state.play)
  const rotate =  useGame((state) => state.rotate)

  const solarOpen = useGame((state) => state.solarOpen)
  const solarFlat = useGame((state) => state.solarFlat)

  const togglePlay = useGame((state) => state.togglePlay)
  const toggleRotate = useGame((state) => state.toggleRotate)

  const toggleOpenAnim = useGame((state) => state.toggleOpenAnim)
  const toggleSolarFlat = useGame((state) => state.toggleSolarFlat)

  const animationAction = useRef()
  
  var sailOpen = false


  if(actions['SolarOpen'] != undefined)
    {
      actions['SolarOpen'].play()
    }

  useEffect(()=>
    {
      if(play === true)
      {
        if(solarOpen === false && solarFlat === false)
        {
            actions['SolarOpen'].loop = false
            actions['SolarOpen'].clampWhenFinished = true
            actions['SolarOpen'].timeScale = 1
            actions['SolarOpen'].repetitions = 0
            actions['SolarOpen'].paused = false
            actions['SolarOpen'].play()
        }

        if(solarOpen === true && solarFlat === false)
          {

            actions['SolarOpen'].loop = false
            actions['SolarOpen'].clampWhenFinished = true
            actions['SolarOpen'].timeScale = -1
            actions['SolarOpen'].repetitions = 0
            actions['SolarOpen'].paused = false
            actions['SolarOpen'].play()
          }
 
      }

      if(rotate === true)
      {
        if(solarOpen === true && solarFlat === false)
          {

            actions['RotationAction'].loop = false
            actions['RotationAction'].clampWhenFinished = true
            actions['RotationAction'].timeScale = 1
            actions['RotationAction'].repetitions = 0
            actions['RotationAction'].paused = false
            actions['RotationAction'].play()
          }

        if(solarOpen === true && solarFlat === true)
          {

            actions['RotationAction'].loop = false
            actions['RotationAction'].clampWhenFinished = true
            actions['RotationAction'].timeScale = -1
            actions['RotationAction'].repetitions = 0
            actions['RotationAction'].paused = false
            actions['RotationAction'].play()
          }
      }
  
      if(play === false)
          {
            actions['SolarOpen'].play()
            actions['SolarOpen'].paused = true
          }

      if(rotate === false)
        {

            actions['RotationAction'].paused = true
        }
  
    },[play, rotate])  


    useFrame(()=>
      {
        if(play === true && solarOpen === false && actions['SolarOpen'].paused === true)
        {
          togglePlay()
          toggleOpenAnim()
        }

        if(play === true && solarOpen === true && actions['SolarOpen'].paused === true)
          {
            togglePlay()
            toggleOpenAnim()
          }

        if(rotate === true && solarFlat === false && actions['RotationAction'].paused === true)
          {
            toggleRotate()
            toggleSolarFlat()
          }

        if(rotate === true && solarFlat === true && actions['RotationAction'].paused === true)
          {
            toggleRotate()
            toggleSolarFlat()
          }
      })

    

      return (
        <group ref={group} {...props} dispose={null}>
          <group name="Scene">
            <group name="Sketchfab_model" rotation={[-Math.PI / 2, 0, 0]}>
              <group name="starlinkobjcleanermaterialmergergles">
                <mesh
                  name="Object_2"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_2.geometry}
                  material={materials.Starlink}
                />
                <mesh
                  name="Object_3"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_3.geometry}
                  material={materials.Starlink}
                />
                <mesh
                  name="Object_4"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_4.geometry}
                  material={materials.Starlink}
                />
              </group>
            </group>
            <group name="Rotation" position={[0.693, 0.2, -0.371]}>
              <group name="Armature" position={[-0.676, 0.006, 0]} scale={0.443}>
                <primitive object={nodes.Bone} />
              </group>
            </group>
          </group>
        </group>
      )
    }
    
    useGLTF.preload('/starlink_spacex_satellite.glb')
